// src/services/servicesApi.ts
import { apiClient } from "@maat/api-base";
var servicesApi = {
  /** `services.create`. Always creates a `draft`; `status` is not accepted. */
  createService: async (data) => {
    return apiClient.post("/main/api/services", data);
  },
  /** `services.list`. `{ items, hasMore }`, filtered and paged in SQL. */
  listServices: async (params) => {
    return apiClient.get("/main/api/services", { params });
  },
  /** `services.view`. The provider AND every priced option on it. */
  getService: async (serviceId) => {
    return apiClient.get(`/main/api/services/${serviceId}`);
  },
  /** `services.update`. REPLACE semantics — send the whole service. */
  updateService: async (serviceId, data) => {
    return apiClient.put(`/main/api/services/${serviceId}`, data);
  },
  /** `services.delete` — the SOFT delete. Refuses while a listing is sellable. */
  archiveService: async (serviceId) => {
    return apiClient.delete(`/main/api/services/${serviceId}`);
  },
  /**
   * `services.publish`. `duration_minutes` is REQUIRED — a service listing IS
   * its length — and must land on the provider's grid, or the answer is
   * `422 LISTING_DURATION_NOT_MULTIPLE` carrying the grid it missed.
   */
  createServiceListing: async (serviceId, data) => {
    return apiClient.post(`/main/api/services/${serviceId}/listings`, data);
  },
  // Photos — the property image pipeline, second owner kind.
  /** `services.update`. Reserves rows and returns one presigned POST per file. */
  presignServiceMedia: async (serviceId, body) => {
    return apiClient.post(`/main/api/services/${serviceId}/media/presign`, body);
  },
  /** `services.update`. Applies deletes + reorder, then presigns the additions. */
  presignServiceImageEdits: async (serviceId, body) => {
    return apiClient.post(`/main/api/services/${serviceId}/images/presign`, body);
  },
  /** `services.view`. Returns UNPUBLISHED rows and AI verdicts too. */
  getServiceImages: async (serviceId) => {
    return apiClient.get(`/main/api/services/${serviceId}/images`);
  },
  /** `services.update`. Flags an AI-declined photo; an admin decides. */
  flagServiceImage: async (serviceId, imageId, body) => {
    return apiClient.post(`/main/api/services/${serviceId}/images/${imageId}/flag`, body);
  }
};

export {
  servicesApi
};
